class HeaderBar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.setSlider();
  }

  setSlider() {
    // console.log(this.dataset.sectionId);
    const swiper = new Swiper(`#Slider-${this.dataset.sectionId}`, {
      // Optional parameters
      loop: true,
      effect: "fade",
      autoplay: true,
      fadeEffect: {
        crossFade: true
      },
      delay: 2000,
      speed: 300,
    });
  }
}
customElements.define('header-bar', HeaderBar);